import { render, staticRenderFns } from "./NormativityBack.vue?vue&type=template&id=073d3522&lang=pug&"
import script from "./NormativityBack.vue?vue&type=script&lang=js&"
export * from "./NormativityBack.vue?vue&type=script&lang=js&"
import style0 from "./NormativityBack.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports